import * as React from 'react';
import { Stack, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/** Props for {@link FormHeader}. */
interface FormHeaderProps {
    /** Called when the close (X) button is clicked. */
    onCancel: () => void;
    /** True: shows the "Update" title | False: shows the "Create" title. */
    isEdit: boolean;
}

/** Header bar for the Source Variable create/edit form: title (create vs. update) plus a close button. */
const FormHeader: React.FC<FormHeaderProps> = ({ onCancel, isEdit }) => {
    return (
        <Stack direction="row" p={2}>
            <Typography variant="h6" gutterBottom flex="1">
                {isEdit && 'Update Source Variable' || 'Create Source Variable'}
            </Typography>
            <IconButton onClick={onCancel} size="small">
                <CloseIcon />
            </IconButton>
        </Stack>
    );
};

export default FormHeader;
